module.exports = __webpack_public_path__ + "media/images/icon_about3-fcba40bc9ef599c890c93cab5c523c2b.png";